import React, { useState } from "react";
import Loading from "../../../../../ReusableFunctions/Loader";
import Popup from "../../../../../ReusableFunctions/Popup";
import Modal from "../../../../../ReusableComponents/Modal";
import Form from "../../../../../ReusableComponents/Form";
import TextAreaField from "../../../../../ReusableComponents/textAreaField";
import { Button } from "../../../../../Components/Helper";
import { updateTermsConditions } from "../../../../../apis/users";

const EditTermsConditions = ({ open, onClose, dsp, onUserUpdate }) => {
  const [termsValue, setTermsValue] = useState(
    dsp?.invoice_terms_and_conditions || "",
  );

  const EditTermsConditionsData = async (dspDetails) => {
    try {
      Loading.set(true);
      console.log("Sending dspData >>>", dspDetails);
      const res = await updateTermsConditions(dspDetails);
      onUserUpdate(res?.updatedDSP);
      Loading.set(false);
      Popup.alert("SUCCESS", "Terms & Conditions Updated", "SUCCESS", onClose);
    } catch (e) {
      Loading.set(false);
      Popup.alert("Error", e || "Something went wrong.", "ERROR");
    }
  };

  return (
    <Modal
      header={"Add Terms & Conditions"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "574px", height: "auto" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <div
        style={{
          padding: "15px 40px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "1.1rem",
        }}
      >
        <div>
          <label
            style={{
              paddingBottom: "7px",
              fontSize: "16px",
              color: "#3b3b3b",
              fontWeight: "400",
              display: "block",
            }}
          >
            Terms & Conditions
          </label>
          <textarea
            placeholder={"Enter Terms And Conditions"}
            value={termsValue}
            maxLength={500}
            onChange={(e) => setTermsValue(e.target.value)}
            style={{
              resize: "none",
              height: "145px",
              padding: "6px 8px",
              background: "#F3F3F3",
              outline: "none",
              width: "100%",
              border: "1px solid #D9D9D9",
              borderRadius: "8px",
              fontSize: "16px",
              fontFamily: "inherit",
              fontWeight: "400",
            }}
          />
        </div>
        <div
          style={{ display: "flex", flexDirection: "row-reverse", gap: "15px" }}
        >
          <Button
            type={"button"}
            text="Update"
            style={{ width: "110px", height: "40px", fontSize: "16px" }}
            onClick={() => {
              if (!dsp?.id) return;
              EditTermsConditionsData({
                invoice_terms_and_conditions: termsValue,
                id: dsp?.id,
              });
            }}
          />
          <Button
            type={"button"}
            onClick={() => onClose()}
            text={"Cancel"}
            isBtnNotActive={true}
            style={{ width: "110px", height: "40px", fontSize: "16px" }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditTermsConditions;
